<!-- 小程序 -->
<template>
  <div class="messageAppearDetail">
    <div class="navBarBox" v-if="!isH5">
      <div class="navBar">
        <img src="@/assets/image/图标-20.png" class="navBarImg" alt @click="backEvent" />
        <div class="navBarTitle">{{ title }}</div>
      </div>
    </div>
    <div v-if="isAuditNoPass" class="auditNoPass">
      <img src="../assets/image_message_appear/iconError@2x.png" alt />
      <div>不合格原因｜{{ checkDescription }}</div>
    </div>
    <!-- {{ store.state.fullpath }} -->
    <div class="mainInfo" id="mainInfo">
      <div class="wayInfo" v-for="(item) in wayDetail" :key="item.index">
        <div class="wayName" v-if="item.index == 0">
          <h4 class="header mg4">
            <span>
              {{ item.title }}
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <!-- <div @click="locationNameGet" :class="['locationGet locationGetHui']">
                {{ message.wayName == '' ?
                    '请输入店招完整名称' :
                    message.wayName }}
            </div> -->
            <input
              id="newAdd"
              type="text"
              class="wayInfo_input goOnInfo"
              v-model="message.wayName"
              placeholder="请输入新增道路的名称"
              maxlength="20"
              @focus="focusInputEvent('newAdd')"
            />
            <img
              :src="ipt_reset"
              alt
              @click="iconClickEvent('wayName')"
              :class="showWayNameIcon ? 'way_name_nut_icon iconShow' : 'way_name_nut_icon iconNone'"
            />
          </div>
          <div v-else class="checkWayName">
            <div class="wayInfo_input" style="border: none;line-height: 52px;">{{ message.wayName }}</div>
          </div>
        </div>

        <div class="wayName" v-if="item.index == '道路报错-1'">
          <h4 class="header mg4">
            <span>
              {{ item.title }}
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <!-- <div @click="locationNameGet" :class="['locationGet locationGetHui']">
                {{ message.wayName == '' ?
                    '请输入店招完整名称' :
                    message.wayName }}
            </div> -->
            <input
              id="rightWay"
              type="text"
              class="wayInfo_input goOnInfo"
              v-model="message.wayName"
              placeholder="请输入正确道路的名称"
              maxlength="20"
              @focus="focusInputEvent('rightWay')"
            />
            <img
              :src="ipt_reset"
              alt
              @click="iconClickEvent('wayName')"
              :class="showWayNameIcon ? 'way_name_nut_icon iconShow' : 'way_name_nut_icon iconNone'"
            />
          </div>
          <div v-else class="checkWayName">
            <div class="wayInfo_input" style="border: none;line-height: 52px;">{{ message.wayName }}</div>
          </div>
        </div>

        <div class="wayName" v-if="item.index == '地点新增-1'">
          <h4 class="header mg4">
            <span>
              {{ item.title }}
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <input
              id="newPoi"
              type="text"
              class="wayInfo_input goOnInfo"
              v-model="message.wayName"
              placeholder="请输入新增地点的名称"
              maxlength="20"
              @focus="focusInputEvent('newPoi')"
            />
            <img
              :src="ipt_reset"
              alt
              @click="iconClickEvent('wayName')"
              :class="showWayNameIcon ? 'way_name_nut_icon iconShow' : 'way_name_nut_icon iconNone'"
            />
          </div>
          <div v-else class="checkWayName">
            <div class="wayInfo_input" style="border: none;line-height: 52px;">{{ message.wayName }}</div>
          </div>
        </div>

        <div v-if="item.index == 1" class="wayPassStatus">
          <h4 class="header">
            <span>
              {{ item.title }}
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <!-- <button
              @click="PassStatusEvent('normal', 1)"
              :class="normalShowDefault ? 'defaultBtn':'activeBtn'"
            >正常通行</button> -->
            <!-- <button
              @click="PassStatusEvent('building', 2)"
              :class="buildingShowDefault ? 'defaultBtn':'activeBtn'"
            >道路在建</button> -->
                   <button
              @click="PassStatusEvent('building', 1)"
              :class="roadNewAdd ? 'defaultBtn':'activeBtn'"
            >道路新增</button>
            <!-- <button
              @click="PassStatusEvent('building', 2)"
              :class="buildingShowbus ? 'defaultBtn':'activeBtn'"
            >交通标志新增</button> -->
          </div>
          <div v-else class="checkWayState">{{ message.subType == 1 ? '道路新增' : '交通标志新增' }}</div>
        </div>
        <div v-if="item.index == 1 && !buildingShowbus" class="wayPassStatus">
          <h4>
            <span class='fixtext'>
              {{ '交通标识信息' }}
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <!-- <button
              @click="PassStatusEvent('trafficSign', 1)"
              :class="buildingDefault.changeCarSignal ? 'defaultBtn':'activeBtn'"
            >可变车信</button> -->
            <button
              @click="PassStatusEvent('trafficSign', 2)"
              :class="buildingDefault.busSignal ? 'defaultBtn':'activeBtn'"
            >公交车信</button>
          </div>
          <div v-else class="checkWayState">{{ buildingDefault.changeCarSignal == false ? '可变车信' : buildingDefault.busSignal == false ? '公交车信' : '' }}</div>
        </div>
        <div v-if="item.index == 1 && !roadNewAdd" class="wayPassStatus">
          <h4>
            <span class='fixtext'>
              {{ '道路通行状态' }}
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <!-- <button
              @click="PassStatusEvent('goThroughState', 1)"
              :class="buildingDefault.normal ? 'defaultBtn':'activeBtn'"
            >正常通行</button> -->
            <button
              @click="PassStatusEvent('goThroughState', 2)"
              :class="buildingDefault.building ? 'defaultBtn':'activeBtn'"
            >道路在建</button>
          </div>
          <!-- <div v-else class="checkWayState">{{ buildingDefault.normal == false ? '正常通行' : buildingDefault.building == false ? '道路在建' : ''  }}</div> -->
          <div v-else class="checkWayState">{{ message.subType == 1 ? '正常通行' : message.subType == 2 ? '道路在建' : ''  }}</div>
        </div>
        <!-- <div v-if="item.index == 1 && buildingShowDefault" class="wayPassStatus">
          <h4 class="header">
              <span>
                {{ '道路通行状态' }}
                <i></i>
              </span>
            </h4>
            <button
              @click="PassStatusEvent('normal', 1)"
              :class="normalShowDefault ? 'defaultBtn':'activeBtn'"
            >正常通行</button>
            <button
              @click="PassStatusEvent('building', 2)"
              :class="buildingShowDefault ? 'defaultBtn':'activeBtn'"
            >道路在建</button>
        </div> -->
        <!-- <div v-if="item.index == 1 && buildingShowDefault" class="wayPassStatus">
          <h4 class="header">
              <span>
                {{ '道路类型' }}
                <i></i>
              </span>
            </h4>
            <button
              @click="PassStatusEvent('normal', 1)"
              :class="normalShowDefault ? 'defaultBtn':'activeBtn'"
            >高速</button>
            <button
              @click="PassStatusEvent('building', 2)"
              :class="buildingShowDefault ? 'defaultBtn':'activeBtn'"
            >城快</button>
        </div>
        <div v-if="item.index == 1 && buildingShowDefault" class="wayPassStatus">
          <h4 class="header">
              <span>
                {{ '道路类型' }}
                <i></i>
              </span>
            </h4>
            <button
              @click="PassStatusEvent('normal', 1)"
              :class="normalShowDefault ? 'defaultBtn':'activeBtn'"
            >高速</button>
            <button
              @click="PassStatusEvent('building', 2)"
              :class="buildingShowDefault ? 'defaultBtn':'activeBtn'"
            >城快</button>
        </div> -->

        <div v-if="item.index == '道路报错-2'" class="wayPassStatus">
          <h4 class="header">
            <span>
              {{ item.title }}
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <!-- <button
              @click="PassStatusEvent('normal', 3)"
              :class="normalShowDefault ? 'defaultBtn':'activeBtn'"
            >改道</button> -->
            <!-- <button
              @click="PassStatusEvent('building', 4)"
              :class="buildingShowDefault ? 'defaultBtn':'activeBtn'"
            >道路不存在/废弃</button> -->
            <button
              style="margin-top: 14px"
              @click="PassStatusEvent('open', 5)"
              :class="openShowDefault ? 'defaultBtn':'activeBtn'"
            >在建道路已开通</button>
          </div>
          <div
            v-else
            class="checkWayState"
          >{{ message.subType == 3 ? '正常通行' : message.subType == 4 ? '道路不存在/废弃' : '在建道路已开通'}}</div>
        </div>

        <div v-if="item.index == 2" class="message_map">
          <h4 class="header">
            <span>
              {{ item.title }}
              <i v-if="title != '地点新增'"></i>
            </span>
          </h4>
          <div @click="PicLoction">
            <!-- <div class="mapBanner" v-if="isH5">
              <iframe
                id="myMap"
                width="100%"
                height="400px"
                frameborder=0
                :src="href"
                >
              </iframe>
            </div> -->
            <div class="mapBanner" v-if="!userCheckDetail">
            <img v-if="!userSelectPoint" :src="mapImg" alt />
              <img v-else :src="mapImgSelected" alt />
            </div>
            <div class="mapBanner" v-else>
              <img :src="mapImgCheck" alt />
            </div>
            <p>地图位置</p> 
          </div>
        </div>

        <div v-if="item.index == 3" class="message_description goOnInfo">
          <h4 class="header">
            <span>
              {{ item.title }}
              <i></i>
            </span>
          </h4>
          <div v-if="!userCheckDetail">
            <nut-textarea max-length="100"
              :placeholder="'可描述' + item.type + '道路的起始位置、预计通车时间、现场情况、核实方式等信息'"
              v-model="message.textareaValue"
            />
          </div>
          <div v-else class="message_usercheck">{{message.textareaValue}}</div>
        </div>

        <div v-if="item.index == 4 || item.index == '地点新增-2'" class="message_uploader goOnInfo">
          <h4 class="header">
            <span>
              {{ item.title }}
              <i v-if="title != '地点新增'"></i>
            </span>
          </h4>
          <div>
            <p v-if="item.index == 4">提供腾讯地图与实际道路不符的证明</p>
            <p v-if="item.index == 4">1.可拍摄现场照片，正面、清晰、完整；如路面情况、道路指示牌，工地的公示牌、平面图等；</p>
            <p v-if="item.index == 4" class="lastP">2.如信息来自网络，优先提供官方半年内在微博/交通官网/公众号发布的信息。</p>
            <p v-if="item.index == '地点新增-2'" class="lastP">照片清晰完整，需要能清楚看到地点名称、外观</p>
            <div v-if="!(title == '地点新增' && defaultFileList.length == 0)" class="uploadEx">
              <img :src="shiliPicList[0]" alt @click="previewImageHandel('示例')" />
              <span>示例</span>
            </div>
            <div v-else class="uploadEx">
              <img :src="shiliPicList[0]" alt @click="previewImageHandel('示例')" />
              <span>示例</span>
            </div>
            <div class="upladItem" v-for="(item2, index2) in defaultFileList" :key="index2">
              <div>
                <nut-cell>
                  <template v-slot:default>
                    <img :src="item2.src" @click="previewImageHandel('证明', index2)" />
                    <nut-icon
                      name="close-little"
                      class="iconDelete"
                      @click="uploadDelete(index2)"
                      v-if="!userCheckDetail"
                    ></nut-icon>
                  </template>
                </nut-cell>
              </div>
              <span class="span">证明图片{{index2 + 1}}</span>
            </div>
            <div class="uploadCss" v-if="!userCheckDetail && defaultFileList.length < 20">
              <div @click="clack">
                <img src="../assets/image_message_appear/camera.png" alt id="imgshow"/>
                <!-- capture="camera" -->
                <input
                  type="file" 
                  accept="image/*"
                  name="file"
                  id="file"
                  @change="fileChange"
                  style="opacity:0"
                  mutiple
                  v-if="isH5"
                  />
                  <!-- 是否直接调用相机 -->
              </div>
              <span>证明图片</span>
            </div>
            <div style="display:none">
            </div>
          </div>
        </div>

        <div v-if="item.index == 5" class="message_link">
          <h4 class="header mg4">{{item.title}}</h4>
          <div v-if="!userCheckDetail">
            <input
              @focus="focusInputEvent('link')"
              id="link"
              placeholder="请输入信息来源的链接（非必填）"
              class="wayInfo_input goOnInfo"
              type="text"
              v-model="message.link"
            />
          </div>
          <div v-else>
            <input
              readonly
              class="wayInfo_input goOnInfo"
              style="width: 100%;"
              type="text"
              v-model="message.link"
            />
          </div>
        </div>
        <!-- <p @click="goweixin">go 微信小程序</p> -->

        <div v-if="item.index == 6" class="message_remake goOnInfo">
          <h4 class="header">{{ item.title }}</h4>
          <div v-if="!userCheckDetail">
            <nut-textarea max-length="100" placeholder="其他需要说明的信息" v-model="message.remake" />
          </div>
          <div v-else class="message_usercheck">{{ message.remake }}</div>
        </div>
      </div>
    </div>
    <div class="appeared">
      <button
        v-if="!userCheckDetail"
        @click="FillInEvent"
        :class="userFillInComplete ? 'complete ' : ''"
      >完成上报</button>
      <button v-else @click="backEvent" :class="userFillInComplete ? 'complete ' : ''">返回</button>
    </div>
    <div class="dialogObscuration" v-if="$store.state.messageAppearDetailVisble">
      <div class="dialogImg">
        <span @click="dialogCancle"></span>
        <span @click="dialogOk"></span>
      </div>
    </div>
    <previewImage
      v-if="showPreviewImg"
      :showPreviewImg="showPreviewImg"
      :photoList="previewImageList"
      :initPage="initPage"
      :isViewExample="isViewExample"
      @setShowPreviewImg="getShowPreviewImg"
    ></previewImage>
    <div v-if="userCheckDetail && !message.wayName" class="history_info_loading">
      <nut-icon name="loading" size="26px"></nut-icon>
    </div>
  </div>
  <maploc v-if="false" @click="changetono"></maploc>
  <nut-overlay  @click="changetono" v-model:visible="locshow" z-index="1000" :lock-scroll="true" :close-on-click-overlay="false">
        <div class="wrapper_overlay" @click="changetono">
            <div class="content">{{ '请点击继续操作' }}</div>
        </div>
  </nut-overlay>
</template>
<script>
import {
  defineComponent,
  onBeforeMount,
  reactive,
  toRefs,
  watch,
  ref,
  // onMounted,
  getCurrentInstance,
  onMounted,
  onBeforeUpdate,
  // nextTick,
} from "vue";
// import apiwx from './wxapi';
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
import { useStore } from "vuex";
import * as api from "@/utils/api";
// import { isPlatformPC } from "@/utils/utils";
import request from "@/utils/request";
import wx from 'weixin-js-sdk';
import * as config from "./config";
import { Notify } from "@nutui/nutui";
import previewImage from "../components/previewImage";
import maploc from "../components/map.vue"
// import {store} from "../store";
const easyearn = window.easyearn;
import Axios from'axios'
const Cos = require("cos-js-sdk-v5");
// const cos = new Cos({
//   getAuthorization: function(options, callback) {
//     // request("post", `${api.requestCosUrlNew}?bucket=mapugc-user`, {
//     //   common: {
//     //     openid: "oA9LiwE6DJWf8WHeXZX4koM8rq2g",
//     //     version: "110211",
//     //     module_id: 1,
//     //   },
//     //   bucket: 'mapugc-user'
//     // },)
//     request("get", `${api.requestCosUrlNew}?bucket=mapugc-user`)
//     .then(data => {
//       callback({
//         TmpSecretId: data.data.tmp_secret_id,
//         TmpSecretKey: data.data.tmp_secret_key,
//         // // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
//         // StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
//         SecurityToken: data.data.session_token,
//         ExpiredTime: data.data.expired_time // 时间戳，单位秒，如：1580000900
//       });
//     });
//   }
// });
// const cos5 = new Cos({
//   getAuthorization: function(options, callback) {
//     request("post", api.requestCosUrl, {
//       common: {
//         openid: "oA9LiwE6DJWf8WHeXZX4koM8rq2g",
//         version: "110211",
//         module_id: 1,
//       },
//     },)
//     // request("get", `${api.requestCosUrlNew}?bucket=mapugc-user`)
//     .then(data => {
//       callback({
//         TmpSecretId: data.data.tmp_secret_id,
//         TmpSecretKey: data.data.tmp_secret_key,
//         // // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
//         // StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
//         SecurityToken: data.data.session_token,
//         ExpiredTime: data.data.expired_time // 时间戳，单位秒，如：1580000900
//       });
//     });
//   }
// });
import {
    setMiniImg
} from '@/utils/utils'
export default defineComponent({
  setup() {
    const { beacon } = getCurrentInstance().appContext.config.globalProperties;
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const cosByScene = new Cos({
      getAuthorization: function(options, callback) {
        request("post", api.getCosCredentialsByScene, {
          scene: 'info_report',
          ext_info: {
            openid: store.state.userOpenId
          }
        })
        .then(data => {
          callback({
            TmpSecretId: data.data.credentials.tmp_secret_id,
            TmpSecretKey: data.data.credentials.tmp_secret_key,
            SecurityToken: data.data.credentials.session_token,
            ExpiredTime: data.data.credentials.expired_time
          });
        });
      }
    })
    // const huituOpenid = huituOpenid();
    const uploader = ref("uploader");
    let data = reactive({
      timestamp: '',
      to: 'ty',
      judge: '',
      title: "道路新增",
      message: {
        wayName: "", // 道路名称
        wayPassStatus: "", // 道路通行状态
        textareaValue: "", // 情报描述
        link: "", // 链接
        remake: "", // 备注
        isAppear: false,
        url: "", // 上传图片的cosLists
        lng: 0,
        lat: 0,
        subType: "", // 按钮类型对应的值
        reportType: "" // 上报类型
      },
      id: "",
      subType: 0, // 道路在建传值内容
      mapImg: config.mapImg,
      ipt_reset: config.ipt_reset,
      mapImgSelected: config.mapImgSelected,
      mapImgCheck: config.mapImgCheck,
      userSelectPoint: false, // 用户是否戳点
      detailItem: {}, // route -- item
      normalShowDefault: true, // 道路通行状态 -- 正常通行 || 改道
      buildingShowbus: true, // 道路通行状态 -- 正常通行 || 改道
      buildingShowDefault: true, // 道路通行状态 -- 道路在建 || 道路不存在/废弃
      roadNewAdd: true, // 道路通行状态 -- 道路在建 || 道路不存在/废弃
      openShowDefault: true, // 道路通行状态 -- 在建道路已开通
      wayDetail: config.wayDetail,
      showWayNameIcon: false, // 显隐  wayName --  icon
      userCheckDetail: false, // 是否处于查看状态
      // 图片列表
      defaultFileList: [],
      enterTime:new Date().getTime(),
      userFillInComplete: false, // 用户是否填写完成
      appearUrl: "", // message的cos地址
      // 上报类型
      reportType: 1,
      // 是否审核未通过
      isAuditNoPass: false,
      // 用户选择地址
      userSelectedLngLat: {},
      // 客户端穿过来的cosList
      cosList: [],
      // 是否展示预览
      showPreviewImg: false,
      // 是否允许退出
      isAllowExit: false,
      // 用户查看时获取的cosUrl
      checkCosUrl: "",
      // 是否为示例
      isViewExample: false,
      // 预览组件监听状态
      addEventStatus: true,
      // 预览列表
      previewImageList: [],
      // 预览当前页
      initPage: 0,
      // 不合格原因
      checkDescription: "",
      // 地图选点
      locshow: false,
      // 示例图片列表
      shiliPicList: [
        require("../assets/image_message_appear/shili.jpg"),
        require("../assets/image_message_appear/shili2.jpg"),
        require("../assets/image_message_appear/shili3.jpg")
      ],
      isH5: false,
      scrollTop: 0,
      version: '326777',
      href: `http://apis.map.qq.com/tools/locpicker?search=1&type=0&key=UV3BZ-DXRLX-GOA4V-7BTFW-AG3Q3-MSBB3&referer=企鹅绘图&coord=${store.state.location}`,
      buildingDefault: {
        normal: true, // 道路通行状态--正常通行
        building: true, // 道路通行状态--道路在建
        highSpeed: true, // 道路类型--高速
        cityRoad: true, // 道路类型--城快
        nationalRoad: true, // 道路类型--国道
        tunnel: true, // 道路类型--隧道
        bridge: true, // 道路类型--桥梁
        otherRoad: true, // 道路类型--其他道路
        changeCarSignal: true, // 交通标识信息--可变车信
        busSignal: true, // 交通标识信息--公交车信
        version: '326555'
      },
      datayime: true,
    });
    data.isH5 = store.state.isH5;
    onMounted(() => {
      console.log(route, '接受小程序参数');
      // 如果加入时间戳考虑避开回显
      window.addEventListener('message', function(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          data.userSelectedLngLat = {
            ...loc.latlng
          }
        }
      }, false);
      localStorage.removeItem('data');
      store.commit('SET_fullpath', 'no');
      if(data.scrollTop * 1 > 0) {
        document.getElementsByClassName('messageAppearDetail')[0].scrollTo(0, data.scrollTop);
        document.getElementById('newPoi').foucs();
      }
      setTimeout(() => {
        data.scrollTop = 0;
      }, 500)
    })
    onBeforeUpdate(() => {
      console.log(route, 'onBeforeUpdate');
      console.log(router, 'onBeforeUpdate');
    } )
    // 路由守卫离开当前路由
    onBeforeRouteLeave((to, from) => {
      if(!data.isAllowExit) {
        if (data.showPreviewImg) {
          data.showPreviewImg = false;
          return false;
        }
        const { href, query } = from;
        console.log(router, 'sssssseeeeeerrrrrrr');
        if (
          href.includes("message_appear_detail") &&
          query.from === 'index'
          ) {
            store.dispatch("setMessageAppearDetailVisble", true);
            return false;
          } else if (
              href.includes("message_appear_detail") &&
              store.state.fullpath != 'no'
          ) {
            store.dispatch("setMessageAppearDetailVisble", true);
            return false;
          }
      }
    })

    const changetono = () => {
      data.locshow = false;
    }
 
 //3.点击事件处理 主要是获取当前页面的url 作为backUrl值然后拼接到href上
 const toSelectAddress = () => {
    console.log(route.fullPath, 'route.fullPath');
   let href = route.fullPath;
   let urlArr = href.split('?');
   data.href = data.href + `&backurl=${urlArr[0]}`
   console.log(data.href);
    // const link = document.createElement('a');
    // link.href = data.href;
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    let af =  handleUrl(data.href);
    console.log(af);
 }
  
 //4.进入地图页面显示是你当前地址附近，你也可以搜索，匹配的地址会显示在页面下方列表中，
 //点击地址就可以回到backurl所指的页面，此时地址相关值会拼接到backurl上
  
 //5.解析携带地址信息的URL，获取信息，我是通过处理把地址信息转化成对象方便使用
 //处理URL
 const handleUrl = function(url) {
   let decodedUrl = decodeURI(url);
   let query = decodedUrl.split('?')[1];
   let queryObj = {};
   if (query) {
     let queryArr = query.split('&');
     queryArr.forEach(item=> {
        let itemArr = item.split('=');
        queryObj[itemArr[0]] = itemArr[1];
      })
   }
   console.log('处理url', queryObj)
   return queryObj;
 }
  
 //到这里你已经获取到了用户经纬度 所选地址 所在城市等信息 如果你想获取更详细的信息 比如省、市、区、街道等等 可以通过腾讯地图逆地址解析来获取。 腾讯地图这个接口是跨域的，可以前端处理也可以让后端处理再返回数据，我是使用jquery通过JSONP的方式处理，代码如下
 //逆解析腾讯地图获取到的地址 location参数是获取到的经纬度
    const parseAddress = (location) => {
       let data = {
          key: "CRRBZ-KBJCU-T5GVR-2PHAY-PNRZO-MYFJN",
          get_poi: '1',
          location,
          output: 'jsonp'
       }
       var url = `https://apis.map.qq.com/ws/geocoder/v1/`;
       let that = this;
        Axios.get({
           dataType: 'jsonp',
           jsonp: "callback",
           jsonpCallback: "parseAddressSucc",
           url: url,
           data: data,
           success: function(res) {
             console.log('成功')
             console.log(res);
             const { address_component } = res.result;
             //复制一份数据
             const copyAddress = JSON.parse(JSON.stringify(that.address));
             copyAddress.province = address_component.province;
             copyAddress.city = address_component.city;
             copyAddress.area = address_component.district;
             copyAddress.address_details = address_component.street +  address_component.street_number;
             that.areas = [address_component.province, address_component.city , address_component.district];
             that.info = copyAddress;
               //业务处理
               console.log(res, '跨域数据')
           },
           error: function(err) {
               //业务处理
               console.log(err, '出错')
           }
  
       });
    }

    onBeforeMount(() => {
      if (store.state.isH5) {
        data.messageTypeLists = config.message_appear_type_listsh5;
        // if(isPlatformPC()){
        //   wx.miniProgram.switchTab({
        //     url: '/pages/userHomePage/userHomePage'
        //   })
        //   return
        // }
      }
      data.timestamp = new Date().getTime().toString(); // 时间戳
      console.log(data.timestamp, 'image.png');
      console.log(route);
      if (store.state.isH5 && route.query.from != "history") {
        data.messageTypeLists = config.message_appear_type_listsh5;
        console.log(store.state.pagelevel);
        data.detailItem = JSON.parse(JSON.stringify(config.message_appear_type_lists[store.state.pagelevel * 1]));
        data.title = data.detailItem.title;
        console.log(data.title, '&page=1');
        data.userCheckDetail = false;
      } else if (route.query.from == "index") {
        data.detailItem = JSON.parse(route.query.name);
        data.title = data.detailItem.title;
        data.userCheckDetail = false;
      } else if (route.query.from == "history") {
        data.id = route.query.id;
        data.title = route.query.name;
        data.checkCosUrl = route.query.cosUrl;
        data.userCheckDetail = true;
        data.userFillInComplete = true;
        route.query.auditStatus === "未通过" && (data.isAuditNoPass = true);
        data.checkDescription = route.query.checkDescription;
        data.href = `http://apis.map.qq.com/tools/locpicker?search=0&mapdraggable=0&total=1&type=0&key=UV3BZ-DXRLX-GOA4V-7BTFW-AG3Q3-MSBB3&referer=企鹅绘图&coord=${store.state.location}`
        // 请求cos的URL
        checkDetailReqCos();
      }
      initData();
      if(store.state.fullpath != 'no' && store.state.isH5) {
          // console.log(router, 'rputer.go(-1)');
          // const hostory = router.getRoutes();
          // console.log(hostory, '"http://192.168.43.96:3000/message_appear_detail?type=h5page&isStaff=true&location=39.90"')
          const rt = JSON.parse(localStorage.getItem('data'))
          if(rt){
            Object.keys(rt).forEach(key => {
                if(key == 'businessTimeAdd') {
                    return;
                }
                data[key] = rt[key]
                console.log(data[key]);
            })
          }
          // data.id = rt.id;
          // data.detailItem = rt.detailItem;
          // data.userCheckDetail = rt.userCheckDetail;
          // data.title = rt.title;
          // data.subType = rt.subType;
          // data.checkCosUrl = rt.checkCosUrl;
          // data.userCheckDetail = rt.userCheckDetail;
          // data.userFillInComplete = rt.userFillInComplete;
          // route.query.auditStatus === "未通过" && (data.isAuditNoPass = true);
          // data.checkDescription = rt.checkDescription;
          // data.href = rt.href;
          // // 请求cos的URL
          // data.message = rt.message;
          // data.normalShowDefault = rt.normalShowDefault;
          // data.buildingShowDefault = rt.buildingShowDefault;
          // data.openShowDefault = rt.openShowDefault;
          // data.buildingShowbus = rt.buildingShowbus;
          // data.roadNewAdd = rt.roadNewAdd;
          // data.buildingDefault = rt.buildingDefault;
          // buildingDefault.building
          // 查看时给图片赋值
          if(rt.message.url) {
            checkUrlGet();
          }
          // 给地图查看点赋值
          data.href = `http://apis.map.qq.com/tools/locpicker?search=0&mapdraggable=0&total=1&type=0&key=UV3BZ-DXRLX-GOA4V-7BTFW-AG3Q3-MSBB3&referer=企鹅绘图&coord=${data.message.lat},${data.message.lng}`
          
          if(store.state.reportSearchWX) {
            let wxdat = JSON.parse(store.state.reportSearchWX);
            data.userSelectedLngLat = {
              lng: wxdat.longitude,
              lat: wxdat.latitude
            };
            // data.message.wayName = wxdat.title;
            data.userSelectPoint = true
          } else {
            data.userSelectedLngLat = {
              lng: data.message.lng,
              lat: data.message.lat
            };
          }
          console.log(data);
          data.scrollTop = rt.scrollTop;
          // data.locshow = true;
          console.log(data.roadNewAdd);
          if (!data.roadNewAdd) {
            if (!data.buildingDefault.building) {
              PassStatusEvent('goThroughState', 2);
              // return;
            } else {

              PassStatusEvent('building', 1);
            }
          }
        }
      // setInterval(function () {
      //   console.log(route, 'ssssssssss');
      // },1000)
    });
    const locationNameGet = () => {
      if (data.userCheckDetail) return
      if(data.datayime) {
        goweixin('name');
        data.datayime = false;
        setTimeout(() => {data.datayime = true } ,3000)
      }
    }
    // 存储桶获取信息
    const checkDetailReqCos = () => {
      const key = data.checkCosUrl.includes('http') ? data.checkCosUrl : 'https://' + data.checkCosUrl
      window.getReadOnlyPresignedUrlApi(key).then(url => {
        console.log(url, 'url');
        getCosJSON(url)
      }).catch(err => console.log(err, 'err'));
    };
    // 获取cos存储的json
    const getCosJSON = url => {
      request("get", url).then(res => {
        console.log(res, 'cosUrssssssssssssssl');
        data.message = res;
        // 给按钮赋值
        switch (data.message.subType) {
          case 1:
            buttonShowDefault("normalShowDefault");
            break;
          case 2:
            buttonShowDefault("buildingShowDefault");
            break;
          case 3:
            buttonShowDefault("normalShowDefault");
            break;
          case 4:
            buttonShowDefault("buildingShowDefault");
            break;
          case 5:
            buttonShowDefault("openShowDefault");
            break;
          default:
            break;
        }
        // 查看时给图片赋值
        checkUrlGet();
        // 给地图查看点赋值
        data.href = `http://apis.map.qq.com/tools/locpicker?search=0&mapdraggable=0&total=1&type=0&key=UV3BZ-DXRLX-GOA4V-7BTFW-AG3Q3-MSBB3&referer=企鹅绘图&coord=${data.message.lat},${data.message.lng}`
        data.userSelectedLngLat = {
          lng: data.message.lng,
          lat: data.message.lat
        };
      });
    };
    // 查看时给图片赋值
    const checkUrlGet = () => {
      let urlArr;
      if (data.message.reportType == 8) {
        urlArr = [];
        console.log(data.message.url);
        if (data.message.url[0] instanceof Object) {
          data.message.url.forEach(item => {
            urlArr.push(item.src)
          })
        } else {
          urlArr = data.message.url.split(";");
        }
      } else {
        urlArr = data.message.url.split(";");
      }
      recivePicPathGetUrl(urlArr);
    };
    // 控制按钮样式
    const buttonShowDefault = type => {
      if (data.message.reportType == 1) {
        data.roadNewAdd = false;
      }
      data.normalShowDefault = true;
      data.buildingShowDefault = true;
      data.openShowDefault = true;
      data.buildingShowbus = true;
      data[type] = false;
    };
      // 监听类型选择
      watch(() => [
      data.roadNewAdd,
    ], (newVal, oldVal) => {
      console.log(newVal, oldVal);
      // 判断类型选择[0]
      if(newVal[0] != oldVal[0]){
        // 清空之前对 道路通行状态 和 道路类型 的选择
        setBuildDefaultHandle()
        // 是否增加道路开通时间
        handleWayDetailAddOrDel(newVal[0], oldVal[0])
      }
    })
    const handleWayDetailAddOrDel = (newVal, oldVal) => {
      // 选择了道路新增
        data.wayDetail = data.wayDetail.slice(0, 5)
      if(newVal == false){
        //data.wayDetail.splice(5, 2)
        const arr = [
          //{
          //  index: 7,
          //  title: '6.道路开通时间'
          //},
          {
            index: 5,
            title: '7. 信息来源链接'
          },
          {
            index: 6,
            title: '备注'
          }
        ]
        data.wayDetail.push(...arr)
      }else if(oldVal == false && newVal == true){
        //data.wayDetail.splice(5, 3)
        const arr = [
          {
            index: 5,
            title: '6. 信息来源链接'
          },
          {
            index: 6,
            title: '备注'
          }
        ]
        data.wayDetail.push(...arr)
      }
    }
    const setBuildDefaultHandle = () => {
      Object.keys(data.buildingDefault).map(item => {
        data.buildingDefault[item] = true;
      })
    }
    // 监听表单必填项是否填写
    watch(
      () => [
        data.message.wayName,  // 名称
        data.message.wayPassStatus,  // 通行状态
        data.message.textareaValue,  // 信息描述
        data.defaultFileList.length,  // 证明图片
        data.userSelectedLngLat,  // 用户选择地址
      ],
      newVal => {
        data.userFillInComplete = false;
        if (data.title === "道路新增" || data.title === "道路报错") {
          if (
            !newVal[0].match(/^[ ]*$/) &&
            newVal[1] !== "" &&
            !newVal[2].match(/^[ ]*$/)  &&
            newVal[3] > 0 &&
            newVal[4]["lng"] !== undefined
          ) {
            data.userFillInComplete = true;
          }
        } else if (data.title === "地点新增") {
          if (
            !newVal[0].match(/^[ ]*$/) 
          ) {
            data.userFillInComplete = true;
          }
        }
      }
    );
    const focusInputEvent = type => {
      document.getElementById(type).setAttribute("placeholder", "");
      data.showWayNameIcon = true;
    };
    // 初始化数据
    const initData = () => {
      switch (data.title) {
        case "道路新增":
          data.wayDetail = config.wayDetail;
          data.reportType = 1;
          break;
        case "道路报错":
          data.wayDetail = config.wayCorrection;
          data.reportType = 2;
          break;
        case "地点新增":
          data.wayDetail = config.poiDetail;
          data.reportType = 3;
          break;
        default:
          break;
      }
    };
    // 位置选好后Android 端通知回调JS端
    window.onLocationPicked = (lng, lat) => {
      console.log("调用成功");
      data.userSelectedLngLat = {
        lng,
        lat
      };
      data.userSelectPoint = true;
    };
    // 客户端地图打点
    const PicLoction = () => {
      toSelectAddress();
      if (data.isH5) {
        if(data.datayime) {
          goweixin();
          data.datayime = false;
          setTimeout(() => {data.datayime = true } ,3000)
        }
        // const key = ''; //使用在腾讯位置服务申请的key
        // const referer = ''; //调用插件的app的名称
        // const location = JSON.stringify({
        //   latitude: 39.89631551,
        //   longitude: 116.323459711
        // });
        // const category = '生活服务,娱乐休闲';
        // wx.miniProgram.getEnv(() => {
        //   wx.chooseLocation({
        //     success: (res) => {
        //       console.log(res, 'res');
        //       this.setData({
        //         location: res
        //       });
        //       // this.backon();
        //     }
        //   });
        // })
        //  toSelectAddress();
        // wx.miniProgram.navigateTo({
        //   url: '/pages/h5location/h5location?form=index' + '&url=' + route.fullPath,
        // });
        // wx.config({
        //      debug:true,// 开启调试模式
        //      appId: 'wxb401eb44282ed315',// 必填，公众号的唯一标识
        //      timestamp: '5050500',// 必填，生成签名的时间戳
        //      nonceStr: '989554215',// 必填，生成签名的随机串
        //      signature: '489454316',// 必填，签名，见附录1
        //      jsApiList: [
        //          'checkJsApi',
        //          'updateTimelineShareData',
        //          'updateAppMessageShareData',
        //          'onMenuShareWeibo',
        //          'getLocation',
        //          'chooseImage',
        //      ]// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        //  })
        // wx.miniProgram.getEnv(function() {
        //   wx.getLocation({
        //     type: 'wgs84',
        //     success(res) {
        //       console.log(res, 'location');
        //     }
        //   })
        // })
      } else {
        if(!data.userSelectedLngLat.lng && data.userCheckDetail) return
        let lat = data.userSelectedLngLat.lat || '0'
        let lng = data.userSelectedLngLat.lng || '0'
        easyearn.picLocation(
          lng,
          lat,
          // data.userSelectedLngLat.lng,
          // data.userSelectedLngLat.lat,
          data.userCheckDetail,
          false
        );
      }
    };
    const dialogOk = () => {
      if(data.locshow) {
        return;
      }
      if(store.state.fullPath != 'no') {
        console.log(router, 'router');
        localStorage.removeItem('data');
        store.commit('SET_fullpath', 'no');
      }
        
      //   // data.isAllowExit = true
      //   // console.log(store.state.fullPath, 'SET_fullpath');
      //   router.go(-(router.getRoutes.length - 2));
      //   return;
      // }
      data.isAllowExit = true
      store.dispatch("setMessageAppearDetailVisble", false);
      // router.push('/message');
      router.go(-1)
    };
    const dialogCancle = () => {
      store.dispatch("setMessageAppearDetailVisble", false);
    };
    // 道路通行状态   按钮
    const PassStatusEvent = (type, subType) => {
      if (type == "normal") {
        data.normalShowDefault = false;
        data.buildingShowDefault = true;
        data.openShowDefault = true;
      } else if (type == "building") {
        data.buildingShowDefault = false;
        data.normalShowDefault = true;
        data.openShowDefault = true;
        data.roadNewAdd = subType == 1 ? false : true; 
        data.buildingShowbus = subType == 1 ? true : false; 
        if(data.buildingShowbus == false) data.reportType = 8
      } else if (type == "open") {
        data.openShowDefault = false;
        data.buildingShowDefault = true;
        data.normalShowDefault = true;
      } else if(type == 'goThroughState'){
        // 处理道路通行状态
        data.buildingDefault.normal = subType == 1 ? false : true;
        data.buildingDefault.building = subType == 1 ? true : false;
      } else if(type == 'wayType'){
        // 道路类型
        data.buildingDefault.highSpeed = subType == 0 ? false : true;
        data.buildingDefault.cityRoad = subType == 1 ? false : true;
        data.buildingDefault.nationalRoad = subType == 2 ? false : true;
        data.buildingDefault.tunnel = subType == 3 ? false : true;
        data.buildingDefault.bridge = subType == 4 ? false : true;
        data.buildingDefault.otherRoad = subType == 5 ? false : true;
      } else if(type == 'trafficSign'){
        // 交通标志新增--交通标识信息
        data.buildingDefault.changeCarSignal = subType == 1 ? false : true;
        data.buildingDefault.busSignal = subType == 1 ? true : false;
      }
      data.message.wayPassStatus = type;
      data.subType = subType;
      // 临时方案，避免正常通行出现
      if(type == 'building' && subType == 1) {
        data.subType = 2;
      }
      // console.log(22222222222245465465465465);
    };
    const backEvent = () => {
      if (data.userCheckDetail) {
        // 上报记录进来
        router.go(-1)
      } else {
        store.dispatch("setMessageAppearDetailVisble", true);
      }
    };
    // icon 点击
    const iconClickEvent = type => {
      if (type == "wayName") {
        data.showWayNameIcon = false;
        data.message.wayName = "";
      }
    };
    // 文件上传点击事件
    const clack = () => {
      if (data.isH5) {
        console.log(222);
        // wx.miniProgram.postMessage({
        //   data:{
        //     name: 'photo',
        //   }});
        console.log(wx.miniProgram)
   
        //调取摄像头  
  //       fileimg.value.clCamera.picture(function (result) {  
  // console.log(result,'result');
  // })
  //       fileimg.value.focus();
        // wx.miniProgram.postMessage({
        //   data:{
        //     type: 'pjou',
        //   }
        // })
        // 需要申请配置信息，未完成
        // wx.miniProgram.getEnv(function() {

        //   wx.chooseImage({
        //     count: 9,
        //     mediaType: ['image','video'],
        //     sourceType: ['album', 'camera'],
        //     maxDuration: 30,
        //     camera: 'back',
        //     success(res) {
        //       console.log(res.tempFiles.tempFilePath)
        //       console.log(res.tempFiles.size)
        //       console.log(res);
        //       data.cosList.push(...res)
        //       console.log(data.cosList,'data.cosList');
        //       recivePicPathGetUrl(res);
        //     }
        //   });
        // })
      } else {
        window.easyearn.takePicture(20 - data.defaultFileList.length);
      }
    };
    const fileChange = async function(){
      // let evt = e || window.event;
      const a = document.getElementById('file');
      console.log(a.files, 'ssssssssssssssssssss');
      // let si = Math.floor(a.files[0]/1024)/1024;
      // if (si < 3) {

        // } else {
          // let a = 
          let  type = 'jpg';
          setMiniImg(a.files[0]).then(miniImgFile => {
            console.log('miniImgFile', miniImgFile);
            if (miniImgFile) {
              if (miniImgFile.type && miniImgFile.type.indexOf('png') > -1) {
                type = 'png';
              }
              CosPutObjectwx(miniImgFile, type)
            } else {
              CosPutObjectwx(a.files[0], type)

          }
        })
      // }
    };
    const fileToBlob = function (file) {
      // 创建 FileReader 对象
      let reader = new FileReader();  
      return new Promise(resolve => {
        // FileReader 添加 load 事件
        reader.addEventListener('load', (e) => {
          let blob;
          if (typeof e.target.result === 'object') {
            blob = new Blob([e.target.result])
          } else {
            blob = e.target.result
          }
          console.log(Object.prototype.toString.call(blob));
          resolve(blob)
        })
        // FileReader 以 ArrayBuffer 格式 读取 File 对象中数据
        reader.readAsArrayBuffer(file)
      })
    }
    // 图片选完后Android 端通知回调JS端
    window.onRecivePicPath = res => {
      data.cosList.push(...res)
      console.log(data.cosList,'data.cosList');
      recivePicPathGetUrl(res);
    };
    const recivePicPathGetUrl = res => {
      console.log(res);
      res.forEach(item => {
        data.judge = item.indexOf('ishare-10003415');
        const cosurl = item.includes('http') ? item : `https://${item}`
        window.getReadOnlyPresignedUrlApi(cosurl).then(url => {
          console.log(url, 'url');
          data.defaultFileList.push({
            src: url,
          });
        }).catch(err => console.log(err, 'err'));
      });
    };
    const recivePicPathGetUrlwxin = res => {
      console.log(res);
      res.forEach(item => {
        data.judge = item.indexOf('ishare-10003415');
        const cosurl = item.includes('http') ? item : `https://${item}`
        window.getReadOnlyPresignedUrlApi(cosurl).then(url => {
          console.log(url, 'url');
          data.defaultFileList.push({
            src: url,
          });
        }).catch(err => console.log(err, 'err'));
      });
    };
    // 文件上次删除事件
    const uploadDelete = index => {
      console.log('delete',index, 'index',data.defaultFileList,'data.defaultFileList' );
      data.defaultFileList.splice(index, 1);
      data.cosList.splice(index, 1);
      // data.defaultFileList.splice(index, 1);
    };
    // 检验表单
    const validator = () => {
      const { wayName, wayPassStatus, textareaValue } = data.message;
      if (wayName === "") {
        Notify.warn("请填写道路名");
        return false;
      } else if (wayPassStatus === "" && data.title != "地点新增") {
        Notify.warn("请填写道路通行状态");
        return false;
      } else if (textareaValue === "" && data.title != "地点新增") {
        Notify.warn("请填写道路信息描述");
        return false;
      }
      // else if (data.userSelectedLngLat["lng"] == undefined) {
      //   Notify.warn("请点击地图打点");
      //   return false;
      // } else if (data.defaultFileList.length === 0) {
      //   Notify.warn("请提供图片");
      //   return false;
      // }
      else {
        return true;
      }
    };
    const throttle = (cd, time = 200) => {
      var t = null;
      return function(){
        if(t) return;
        t = setTimeout(() => {
          cd.call(data);
          t = null;
        }, time);
      };
    }
    // 完成上报
    const FillInEvent = () => {
      // throttle(() => {
        if (!validator()) return;
        if(data.userFillInComplete == false) return
        if (data.userCheckDetail) {
          router.go(-1)
        } else if (!data.userCheckDetail) {
          if (data.reportType == 1) {
            beacon.onUserAction("road_add_finish", { duration: (new Date().getTime()-data.enterTime)/1000,add_road_status:data.subType});
          } else if (data.reportType == 2) {
            beacon.onUserAction("road_fix_finish", { duration: (new Date().getTime()-data.enterTime)/1000,fix_road_status:data.subType});
          } else if (data.reportType == 3) {
            beacon.onUserAction("poi_add_finish",{ duration: (new Date().getTime()-data.enterTime)/1000});
          }
          let urllist = [];
          data.cosList.forEach(item => {
            console.log('itemmmmmmmmmmmmm');
            if(item.indexOf('http') > -1) {
              urllist.push(item)
            } else {
              urllist.push(`http://${item}`)

            }
          })
          const { lng, lat } = data.userSelectedLngLat;
          data.message.adcode = ''
          if(!data.buildingDefault.changeCarSignal) {
            let url = `https://apis.map.qq.com/ws/geocoder/v1/?location=${lat + ',' + lng}`+
            '&key=74JBZ-LKNWV-IMQPH-UNVI7-OAQWE-SJFJR'
            request("get", url).then(res => {
            if (res.status == 0) {
              data.message.adcode = res.result.address_component.city;
            } else if (res.status !== 0) {
              // Message.warn("请求城市失败");
              Notify.warn("请求城市失败");
              console.log(res);
            }})
          }
          data.message.uid = new Date().getTime();
          data.message.isAppear = true;
          data.message.reportType = data.reportType;
          data.message.subType = data.subType;
          data.message.url = urllist.join(';');
          data.message.lng = lng;     
          data.message.lat = lat;
          data.userFillInComplete = false
          CosPutObject(data.message);
        }
      // }, 3000)()
    };
    // 推送文件到COS
    const CosPutObject = fileItem => {
      console.log(store.state.userOpenId, 'store.getters.useropenid');
      if (data.judge > -1) {
        const key = `easyearn/info_report/${store.state.userOpenId}/road/evaluating/${new Date().getTime()}/${
          fileItem.uid
        }.json`;
        cosByScene.putObject(
          {
            Bucket: "ishare-10003415" /* 必须 */,
            Region: "ap-shanghai" /* 存储桶所在地域，必须字段 */,
            Key: key /* 必须 */,
            StorageClass: "STANDARD",
            Body: JSON.stringify(fileItem), // 上传文件对象
            onProgress: function() {}
          },
          function(err, datas) {
            console.log(err, 'errs');
            console.log(datas, 'datas');
            if (!datas) {
              Notify.warn("上传失败, 请重试");
              data.userFillInComplete = true;
              return;
            }
            if (fileItem.isAppear) {
              data.appearUrl = datas.Location;
              finallyAppear();
            } else {
              if (data.defaultFileList[data.defaultFileList.length - 1]) {
                data.defaultFileList[data.defaultFileList.length - 1].location =
                  datas.Location;
              }
            }
          }
        );
      } else {
        let a = store.state.userOpenId
        console.log(a,'store.getters.userInfo12');
        const key = `easyearn/info_report/${store.state.userOpenId}/road/evaluating/${ a || 'oA9LiwK_7Hi3VC-BVHBc6WRQFbew' }/${new Date().getTime()}/${
          fileItem.uid
        }.json`;
        cosByScene.putObject(
          {
            Bucket: 'mapugc-user-1251316161' /* 必须 */,
              // Region: 'ap-shanghai' /* 存储桶所在地域，必须字段 */,
            Region: 'ap-beijing' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
            Key: key /* 必须 */,
            StorageClass: "STANDARD",
            Body: JSON.stringify(fileItem), // 上传文件对象
            onProgress: function() {}
          },
          function(err, datas) {
            console.log(err,'err');
            console.log(datas,'data');
            if (!datas) {
              Notify.warn("上传失败, 请重试");
              data.userFillInComplete = true;
              return;
            }
            if (fileItem.isAppear) {
              data.appearUrl = datas.Location;
              finallyAppear();
            } else {
              if (data.defaultFileList[data.defaultFileList.length - 1]) {
                data.defaultFileList[data.defaultFileList.length - 1].location =
                  datas.Location;
              }
            }
          }
         );
      }
    };
    // 推送文件到COS wexin
    const CosPutObjectwx = async (fileItem, type) => {
      console.log(store.getters, 'store.getters');
        let a = store.state.userOpenId
        console.log(a,'store.getters.userInfo12');
        // let img = await fileToBlob(fileItem);
        console.log(fileItem);
        console.log(fileItem.name);

        const key = `easyearn/info_report/${store.state.userOpenId}/road/evaluating/${ a || 'oA9LiwK_7Hi3VC-BVHBc6WRQFbew' }/${new Date().getTime()}.${type}`;
        cosByScene.putObject(
          {
            Bucket: 'mapugc-user-1251316161' /* 必须 */,
              // Region: 'ap-shanghai' /* 存储桶所在地域，必须字段 */,
            Region: 'ap-beijing' /* 存储桶所在地域，例如ap-beijing，必须字段 */,
            Key: key /* 必须 */,
            StorageClass: "STANDARD",
            Body: fileItem, // 上传文件对象
            onProgress: function() {}
          },
          function(err, datas) {
            console.log(err,'err');
            console.log(datas,'data');
            if (!datas) {
              Notify.warn("上传失败");
              return;
            }
            if (datas.Location) {
              data.appearUrl = datas.Location;
              console.log(datas.Location);
              // if (data.Location.indexOf('http') > -1) {

                data.cosList.push(datas.Location);
              // } else {
              //   data.cosList.push(`http://{datas.Location}`);
              // }
              recivePicPathGetUrlwxin([data.appearUrl]);
            }
            if (fileItem.isAppear) {
              // finallyAppear();
            } else {
              if (data.defaultFileList[data.defaultFileList.length - 1]) {
                data.defaultFileList[data.defaultFileList.length - 1].location =
                  datas.Location;
              }
            }
          }
         );
    };
    // const dataURLtoBlob = function (dataurl, filename) {
    //   console.log(filename);
    //   var arr = dataurl.split(','),
    //       mime = arr[0].match(/:(.*?);/)[1],
    //       bstr = atob(arr[1]),
    //       n = bstr.length,
    //       u8arr = new Uint8Array(n);
    //   while (n--) {
    //       u8arr[n] = bstr.charCodeAt(n);
    //   }
    //   return new Blob([u8arr], { type: mime });
    // }
    // 调用情报上报接口
    const finallyAppear = () => {
      const { lng, lat } = data.userSelectedLngLat;
      let openId = store.getters.userInfo ? 
        store.getters.userInfo.split('/')[0] : null;
      let obj = {
        common: {
          version: "3.16.0",
          module_id: "2",
          vcode: "31600000",
          loc_x: lat,
          loc_y: lng
        },
        sourceFrom: store.state.isH5 ? 2 : 1, // 1 app 2 小程序
        reportType: data.reportType,
        subType: data.subType,
        reportName: data.message.wayName,
        cosUrl: `http://${data.appearUrl}`
      }
      console.log(data.buildingDefault.changeCarSignal, 'data.buildingDefault.changeCarSignal');
      if(!data.buildingDefault.changeCarSignal) {
            // data.message.adcode = 
            let url = `https://apis.map.qq.com/ws/geocoder/v1/?location=${lat + ',' + lng}`+
            '&key=74JBZ-LKNWV-IMQPH-UNVI7-OAQWE-SJFJR'
            request("get", url).then(res => {
              console.log(res);
            if (res.status == 0) {
              obj.adcode = res.result.address_component.city;
            } else if (res.status !== 0) {
              // Message.warn("请求城市失败");
              Notify.warn("请求城市失败");
              console.log(res, 'http://cdn.map.qq.com/miniprogram/images/failphoto/safewarning.png');
            }})
          }
      store.getters.haveOpenId ? obj['common']['openid'] = openId : ''
      request("post", api.infoReport, obj).then(res => {
        if (res.code == 0) {
          data.isAllowExit = true
          router.replace('/report_success')
        } else if (res.code !== 0) {
          Notify.warn("上报失败，请重试");
          data.userFillInComplete = true;
        }
      });
    };
    // 预览方法
    const previewImageHandel = (type, index) => {
      if (type === "示例") {
        data.previewImageList = JSON.parse(JSON.stringify(data.shiliPicList));
        data.initPage = 0;
        data.isViewExample = true;
      } else if (type === "证明") {
        data.previewImageList = JSON.parse(
          JSON.stringify(data.defaultFileList)
        );
        data.initPage = index;
        data.isViewExample = false;
      }
      data.showPreviewImg = true;
    };
    // 获取预览状态
    const getShowPreviewImg = val => {
      data.showPreviewImg = val;
    };
    const goweixin = (va = 'location') => {
      let fullPath = route.fullPath;
      data.to = 'sss'
      data.scrollTop = document.getElementsByClassName('messageAppearDetail')[0].scrollTop;
      // document.getElementsByClassName('messageAppearDetail')[0].scrollTo(0, document.getElementsByClassName('messageAppearDetail')[0].scrollTop + 100);
      // data.buildingDefault.building = true;
      console.log(data.buildingDefault);
      localStorage.setItem('data', JSON.stringify(data))
      // document
      console.log(fullPath);
      // return;

      // 给url添加这个参数  // &latitude=${}&longitude=${}  data下新增latitude,longitude并且默认值是undefinde
      if(va == 'name'){
        // wx.miniProgram.navigateTo({url: `/pages/H5PoiReportSearch/H5PoiReportSearch?name=${data.message.wayName}&reportType=${data.reportType}&from=h5HuiTu&url=${fullPath}`});
        return
      }else if(va == 'location'){
        wx.miniProgram.navigateTo({url: `/pages/H5PicLocation/H5PicLocation?userCheckDetail=${data.userCheckDetail}&latitude=${data.userSelectedLngLat.lat}&longitude=${data.userSelectedLngLat.lng}&reportType=${data.reportType}&from=h5HuiTu&url=${fullPath}`}) 
        return
      }




      // router.go(-1);
      // dialogOk();
    }
    return {
      ...toRefs(data),
      changetono,
      backEvent,
      store,
      route,
      PassStatusEvent,
      goweixin,
      iconClickEvent,
      FillInEvent,
      validator,
      dialogCancle,
      dialogOk,
      clack,
      CosPutObject,
      PicLoction,
      // fileimg,
      uploader,
      uploadDelete,
      checkDetailReqCos,
      locationNameGet,
      buttonShowDefault,
      checkUrlGet,
      recivePicPathGetUrl,
      // showPreviewImg,
      previewImageHandel,
      getShowPreviewImg,
      focusInputEvent,
      throttle,
      fileChange,
      CosPutObjectwx,
      parseAddress,
      handleUrl,
      toSelectAddress,
      fileToBlob,
      setBuildDefaultHandle,
    };
  },
  components: {
    previewImage,
    maploc
  }
});
</script>
<style lang="scss" scoped>
  .wrapper_overlay {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    color: white;
    .content {
        display: flex;
        width: 85%;
        height: 60px;
        background: #fff;
        border-radius: 8px;
        align-items: center;
        justify-content: center;
        color: red;
        font-size: 14px;
    }
  }
#file{
  position: relative;
    left: 0;
    width: 100%;
    height: 100%;
    top: -80px;
    height: 100%;
    opacity: 0;
}
.fixtext{
  font-family: NotoSansCJKsc-Medium;
  font-weight: 800;
  font-size: 14px;
  color: rgba($color: #000000, $alpha: 0.7);
  line-height: 20px;
}

.goOnInfo {
        // width: 96%;
        // height: 100px;
        // margin-bottom: 150px;
        // //opacity: 0.6;
        // background: #F6F6F9;
        // border-radius: 4px;
        // outline: none;
        // border: none;
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 20px !important;
        // padding: 10px 10px 0px !important;
        color:black !important;
        & :deep(nut-textarea){
          // padding: 10px 10px 0px;
          // margin-left: -10px;
          padding: 10px 10px 0;
        }
    }
#mapbox {
  width: 100vw;
  height: 100vh;
}
button,
input {
  outline: none;
}
.messageAppearDetail {
  position: relative;
  overflow: scroll;
  height: 100vh;
  .navBarBox {
    height: 66px;
  }
  .checkWayName {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
  .navBar {
    padding: 35px 0 11px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0 2px 14px 0 rgba(0, 136, 255, 0.06);
    .navBarImg {
      position: absolute;
      width: 20px;
      height: 20px;
      left: 20px;
      line-height: 20px;
    }
    .navBarTitle {
      font-size: 16px;
      line-height: 20px;
      font-weight: Bold;
      text-align: center;
    }
  }
  .locationGet {
    font-size: 14px;
    height: 52px;
    line-height: 52px;
}

  .locationGetHui {
    color: #c8c9cc;
  }
  .checkWayState {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
  .auditNoPass {
    margin-right: 0;
    height: 44px;
    background: rgb(255, 68, 51, 0.08);
    display: flex;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
      margin-left: 20px;
    }
    div {
      display: inline-block;
      margin-left: 5px;
      font-family: NotoSansCJKsc-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #ff4433;
    }
  }
  .mainInfo {
    background-color: #fff;
    padding-bottom: 100px;
    & .header {
      opacity: 0.9;
      // font-family: NotoSansCJKsc-Bold;
      font-family:Arial, Helvetica, sans-serif;
      font-weight: Bold;
      font-size: 16px;
      color: #000000;
      line-height: 22px;
      margin-bottom: 12px;
      margin-top: 24px;
      & i {
        display: inline-block;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #ff4433;
        position: absolute;
        right: -8px;
        top: 3px;
      }
      & span {
        display: inline-block;
        position: relative;
      }
    }
    & .mg4 {
      margin-bottom: 4px;
    }
    & .wayInfo {
      width: 90%;
      margin: 0 auto;
      padding-top: 6px;
      & .way_name_nut_icon {
        position: absolute;
        right: 0;
        bottom: 12px;
        width: 28px;
        height: 28px;
      }

      & .iconShow {
        display: inline-block;
      }
      & .iconNone {
        display: none;
      }
      & .wayInfo_input {
        width: 92%;
        border: none;
        height: 52px;
      }
      input::-webkit-input-placeholder {
        color: #c8c9cc;
        font-size: 14px;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #c8c9cc;
        font-size: 14px;
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #c8c9cc;
        font-size: 14px;
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #c8c9cc;
        font-size: 14px;
      }
      & .wayName {
        position: relative;
        & div {
          border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
        }
      }
      & .wayPassStatus {
        & button {
          width: 44%;
          height: 38px;
          border-radius: 4px;
          font-weight: 500;
          font-size: 14px;
          text-align: center;
          line-height: 14px;
        }
        & button:nth-child(1) {
          margin-right: 5%;
        }
        & .defaultBtn {
          color: #000000;
          border: 1px solid rgba($color: #17181a, $alpha: 0.15);
          background: rgba($color: #fff, $alpha: 0.15);
        }
        & .activeBtn {
          background: #e5f3ff;
          border: 1px solid #0088ff;
          color: #0088ff;
        }
      }
      & .message_map {
        .mapBanner {
          width: 100%;
        }
        img {
          width: 100%;
          display: block;
        }
        p {
          font-weight: 5000;
          font-size: 12px;
          text-align: center;
          color: rgba($color: #000000, $alpha: 0.5);
          margin-top: 8px;
        }
      }
      & .message_description {
        div {
          // opacity: 0.6;
          // background: #f0f1f5;
          background-color: rgba($color: #f0f1f5, $alpha: 0.6);
          border-radius: 4px;
          & :deep(.nut-textarea) {
            background-color: transparent;
            height: 100%;
            min-height: 80px;
          }
          & :deep(.nut-textarea__textarea) {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .message_usercheck {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          background: #fff;
          border-radius: 0px;
          opacity: 1;
        }
      }
      & .message_uploader {
        font-family: NotoSansCJKsc-Medium;
        font-weight: 500;
        font-size: 14px;
        color: rgba($color: #000000, $alpha: 0.7);
        line-height: 20px;
        & :deep(.nut-uploader) {
          margin-top: 12px;
        }
        .lastP {
          margin-bottom: 12px;
        }
        .uploadEx {
          display: inline-block;
          width: 80px;
          height: 106px;
          vertical-align: top;
          margin-right: 10px;
          margin-bottom: 16px;
          img {
            width: 100%;
            height: 80px;
            display: block;
            border-radius: 4px;
          }
          span {
            opacity: 0.5;
            font-weight: 500;
            font-size: 12px;
            text-align: center;
            display: block;
            margin-top: 9px;
          }
        }
        .upladItem {
          display: inline-block;
          width: 80px;
          height: 106px;
          vertical-align: top;
          margin-right: 10px;
          margin-bottom: 16px;
          & :deep(.nut-cell) {
            width: 100%;
            height: 100%;
            padding: 0;
            margin: 0;
            border-radius: 4px;
            overflow: hidden;
            .iconDelete {
              width: 14px;
              height: 14px;
              background: rgba(0, 0, 0, 0.7);
              color: white;
              position: absolute;
              top: 4px;
              right: 4px;
              font-size: 6px;
              border-radius: 50%;
            }
          }
          img {
            width: 80px;
            height: 80px;
            border-radius: 4px;
          }
          .span {
            opacity: 0.5;
            font-weight: 500;
            font-size: 12px;
            text-align: center;
            display: block;
            margin-top: 9px;
          }
        }
        .uploadCss {
          width: 80px;
          height: 106px;
          display: inline-block;
          vertical-align: top;
          div {
            width: 100%;
            height: 80px;
            background: rgba(0, 136, 255, 0.1);
            border-radius: 4px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 4px;
            }
          }
          span {
            opacity: 0.5;
            font-weight: 500;
            font-size: 12px;
            text-align: center;
            display: block;
            margin-top: 9px;
          }
        }
      }
      & .message_link {
        & div {
          border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
        }
      }
      & .message_remake {
        & div {
          // opacity: 0.6;
          background-color: rgba($color: #f0f1f5, $alpha: 0.6);
          // background: #f0f1f5;
          border-radius: 4px;
        }
        & :deep(.nut-textarea) {
          background-color: transparent;
          height: 100%;
        }
        & :deep(.nut-textarea__textarea) {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
        }
        .message_usercheck {
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          background: #fff;
          // background-color: rgba($color: #fff, $alpha: 1);
          border-radius: 0px;
          opacity: 1;
        }
      }
    }
  }
  .appeared {
    position: fixed;
    width: 100%;
    bottom: 0;
    padding: 19px 0;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.05);
    & button {
      width: 90%;
      padding: 13px 0;
      border: none;
      background-color: #e5f3ff;
      border-radius: 38px;
      font-weight: Bold;
      font-size: 16px;
      color: #fff;
      text-align: center;
      line-height: 16px;
      -webkit-tap-highlight-color: rgb(0, 0, 0, 0);
      -webkit-tap-highlight-color: transparent;
      outline: none;
    }
    .complete {
      background-color: #0088ff;
    }
  }
  .dialog_info {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    line-height: 21px;
  }
  .dialogObscuration {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 4;
    .dialogImg {
      background: url("../assets/image_message_appear/messageAppearDetail.png");
      background-size: 320px 171px;
      width: 320px;
      height: 171px;
      position: fixed;
      top: 50%;
      margin-top: -85px;
      left: 50%;
      margin-left: -160px;
      span {
        display: inline-block;
        position: absolute;
        width: 92px;
        height: 42px;
        bottom: 20px;
        border-radius: 21px;
      }
      span:nth-of-type(1) {
        right: 112px;
      }
      span:nth-of-type(2) {
        right: 20px;
      }
    }
  }
  .history_info_loading {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    background: white;
    z-index: 2;
    i {
      position: fixed;
      top: 40%;
      left: 50%;
      margin-left: -13px;
    }
  }

}
</style>
